export const SUPPORTS_ARRAY_PROTOTYPE_UNSHIFT = "unshift" in Array.prototype;
